import React from 'react';
import moment from 'moment';

import { FeedbackTile, Text } from 'shell/components';

const feedback = [
    {
        id: '1',
        active: true,
        created_on: moment().subtract(5, 'hours').valueOf(),
        modified_on: moment().subtract(4, 'hours').valueOf(),
        owner_account_id: '1',
        text: 'Let me know if you need additional resources, I may have some stored away that could be useful.',
    },
    {
        id: '2',
        active: true,
        created_on: moment().subtract(2, 'hours').valueOf(),
        modified_on: moment().subtract(2, 'hours').valueOf(),
        owner_account_id: '2',
        text: 'Will do, thank you!',
    },
    {
        id: '3',
        active: true,
        created_on: moment().subtract(30, 'minute').valueOf(),
        modified_on: moment().subtract(30, 'minute').valueOf(),
        owner_account_id: '2',
        text: 'Here are some files. Check out www.example.com .',
        files: [
            {
                id: '1',
                active: true,
                created_on: moment().subtract(30, 'minute').valueOf(),
                data: { key: '1', name: 'Microsoft Analysis.pdf', type: 'application/pdf' },
                owner_account_id: '2',
            },
            {
                id: '2',
                active: false,
                created_on: moment().subtract(30, 'minute').valueOf(),
                data: { key: '2', name: 'Apple Analysis.docx', type: 'application/msword' },
                owner_account_id: '2',
            },
        ],
    },
];

const authors = [
    {
        id: '1',
        first_name: 'Georgina',
        last_name: 'Watson',
        profile_circle: {
            bg_color: '#991b1b',
            text_color: '#ffffff',
        },
        role: 'student',
    },
    {
        id: '2',
        first_name: 'Steven',
        last_name: 'Andrews',
        profile_circle: {
            bg_color: '#991b1b',
            text_color: '#ffffff',
        },
        role: 'instructor',
    },
];

const getAuthor = (feedback) => {
    const { owner_account_id } = feedback;
    return authors.find(({ id }) => id === owner_account_id);
};

const getName = (id) => {
    const author = authors.find((author) => author.id === id);
    return author.preferred_name
        ? `${author.preferred_name} ${author.last_name}`
        : `${author.first_name} ${author.last_name}`;
};

const FeedbackTileDemo = () => {
    return (
        <>
            <Text variant={'sh1'}>FeedbackTile</Text>
            {feedback.map((feedback) => (
                <FeedbackTile
                    key={feedback.id}
                    author={getAuthor(feedback)}
                    feedback={feedback}
                    getFileOptions={() => {
                        return [
                            { key: 'download', value: 'Download' },
                            { key: 'delete', value: 'Delete' },
                        ];
                    }}
                    getNameById={(id) => getName(id)}
                    options={[
                        { key: 'edit', value: 'Edit' },
                        { key: 'delete', value: 'Delete' },
                    ]}
                    onSelect={console.log}
                    onSelectFile={console.log}
                />
            ))}
        </>
    );
};

export default FeedbackTileDemo;
